import styled from "@emotion/styled"
import { AssetKeySvg } from "custom/asset_key"
import { signal, Signal } from "@preact/signals"
import { createLogger } from "@/utils/logger"
import { resolveAssetSvg } from "@/utils/common"
import { Suspense } from "react"

const logger = createLogger("components/base/Svg")

const SvgStyled = styled.svg``

type SvgProps = ExtractStyledProps<typeof SvgStyled>

type Props = Omit<SvgProps, "src"> & {
    src: AssetKeySvg
}

// 創建一個 signal map 來緩存已解析的 SVG 組件
const svgSignalMap = new Map<string, Signal<React.ComponentType<SvgProps>>>()

function getSvgSignal(src: AssetKeySvg) {
    if (!svgSignalMap.has(src)) {
        const module = resolveAssetSvg(src)
        // @ts-ignore
        const component = module?.default || module
        const newSignal = signal(component)
        svgSignalMap.set(src, newSignal)
    }
    return svgSignalMap.get(src)!
}

export default function Svg(props: Props) {
    const { src: assets_src, ...rest } = props
    const SvgComponentSignal = getSvgSignal(assets_src)
    const SvgComponent = SvgComponentSignal.value

    return (
        <Suspense>
            <SvgComponent {...rest} />
        </Suspense>
    )
}

export function SvgComponent(src: AssetKeySvg) {
    const svgSignal = getSvgSignal(src)

    return function SvgComponentWrapper(props: SvgProps) {
        const Component = svgSignal.value
        return (
            <Suspense>
                <Component {...props} />
            </Suspense>
        )
    }
}
